import { render, staticRenderFns } from "./OpenQuestionComponent.vue?vue&type=template&id=998b46ee&scoped=true"
import script from "./OpenQuestionComponent.vue?vue&type=script&lang=js"
export * from "./OpenQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./OpenQuestionComponent.vue?vue&type=style&index=0&id=998b46ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998b46ee",
  null
  
)

export default component.exports